import React from 'react';

import { getConsulData } from 'UtilityComponents/index';
import { ROLE_ACCESS_STORE_CONST } from 'reduxStore/actionConstants';

import { ASSET_PATH } from '../../assetsPath';

import { EmployeeIcons } from '../Employee/styles';

export const ROLE_ACCESS_NOTIFICATION_MESSAGES = {
	[ROLE_ACCESS_STORE_CONST.CREATE_ROLE]: {
		error: 'We couldn\'t create the role due to technical reasons. Please try again later.'
	},
	[ROLE_ACCESS_STORE_CONST.UPDATE_ROLE]: {
		success: 'Role updated successfully.',
		error: 'We couldn\'t update the role due to technical reasons. Please try again later.'
	},
	[ROLE_ACCESS_STORE_CONST.DELETE_ROLE]: {
		success: 'Role deleted successfully.',
		error: 'We couldn\'t delete the role due to technical reasons. Please try again later.'
	}
} as const;

const roleAccessOnboardImage = `${ASSET_PATH.IMAGES}role/role-onboard.png`;

export const CREATE_UPDATE_ROLE_CONSTANTS = {
	MODAL_TITLE_CREATE: 'Create Role',
	MODAL_TITLE_EDIT: 'Edit Role',
	MODAL_DESCRIPTION: 'Define a custom role name and description. You will configure permissions and add users in the next steps.',
	MODAL_DESCRIPTION_EDIT: 'Update the role name, description, and permissions as needed.',
	PERMISSIONS_TITLE: 'Configure Permissions',
	PERMISSIONS_DESCRIPTION: 'You can set view and edit access for each of the modules',
	SAVE_BUTTON_TEXT: 'SAVE ROLE DETAILS',
	UPDATE_BUTTON_TEXT: 'UPDATE ROLE DETAILS',
	HEADER_MODULE: 'Module',
	HEADER_VIEW_ACCESS: 'View Only Access',
	HEADER_EDIT_ACCESS: 'Edit Access',
	PERMISSION_KEYS: {
		VIEW_ONLY: 'viewOnly',
		EDIT: 'edit'
	}
};

export const getRoleModules = () => getConsulData('adminPageModulesMap') || {};

export const createRoleFields = {
	roleName: {
		name: 'roleName',
		label: 'Role Name',
		placeHolder: 'Enter role name',
		value: '',
		type: 'text',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		errorOnBlur: true,
		isMandatory: true,
		outLabel: true
	},
	roleDescription: {
		name: 'roleDescription',
		label: 'Role Description',
		placeHolder: 'Enter role description',
		value: '',
		type: 'textArea',
		rows: 4,
		errorOnBlur: true,
		outLabel: true
	}
};

export const createAndUpdateRoleModalData = {
	title: '',
	customClass: 'createAndUpdateRoleModal',
	closeBtnClass: 'close-ico'
};

export const ACCESS_LEVELS = {
	WRITE: 'WRITE',
	READ: 'READ',
	VOID: 'VOID'
} as const;

export const ROLE_SUCCESS_MODAL_CONFIG = {
	TITLE: 'Role Successfully Created!',
	DESCRIPTION_PREFIX: 'You have created the role of "',
	DESCRIPTION_SUFFIX: '" for your organisation. You can view and edit the role and its permitted accesses whenever required.',
	QUESTION: 'Would you like to assign employees for this role?',
	BTN_LATER: 'I\'LL ASSIGN LATER',
	BTN_ASSIGN: 'YES, ASSIGN NOW'
};

export const ASSIGN_USERS_TO_ROLE_CONFIG = {
	MODAL_TITLE: 'Add Users',
	MODAL_SUBTITLE: 'You can select the users from your organisation for this role.',
	SEARCH_LABEL: 'Employee Name or Email ID',
	SEARCH_PLACEHOLDER: 'Enter employee name or email ID',
	UPLOAD_TITLE: 'Upload a file',
	UPLOAD_SUBTITLE: 'Upload a file with the list of employees for this role (.xlsx)',
	EMPTY_STATE_TEXT: 'You have not chosen any employees for this role yet',
	BTN_GO_BACK: 'GO BACK',
	BTN_SAVE: 'SAVE ROLE PREFERENCES',
	OR_TEXT: 'OR',
	SELECTED_EMPLOYEES_TITLE: 'Selected Employees'
};

export const assignUsersToRoleModalData = {
	title: ASSIGN_USERS_TO_ROLE_CONFIG.MODAL_TITLE,
	subTitle: ASSIGN_USERS_TO_ROLE_CONFIG.MODAL_SUBTITLE,
	customClass: 'assignUsersToRoleModal',
	closeBtnClass: 'close-ico'
};

export const DELETE_ROLE_CONFIRMATION_CONFIG = {
	TITLE: 'Are you sure you want to delete this role?',
	DESCRIPTION: 'If you choose to delete this role, the action can not be undone. You will have to create the role anew if you wish to have it again.',
	ROLE_NAME_LABEL: 'ROLE NAME',
	ROLE_DESCRIPTION_LABEL: 'ROLE DESCRIPTION',
	ASSIGNED_USERS_LABEL: 'ASSIGNED USERS',
	CONFIGURED_PERMISSIONS_LABEL: 'CONFIGURED PERMISSIONS',
	BTN_DELETE: 'YES, DELETE',
	USERS_SUFFIX: 'Users',
	MODULES_SUFFIX: 'Modules permitted'
};

export const deleteRoleConfirmationModalData = {
	title: '',
	customClass: 'deleteRoleConfirmationModal',
	closeBtnClass: 'close-ico'
};

export const ROLE_ACCESS_CONSTANTS = {
	CREATE_ROLE_MODAL: 'CREATE_NEW_ROLE',
	ROLE_SUCCESS_MODAL: 'ROLE_SUCCESS_MODAL',
	ASSIGN_USERS_TO_ROLE: 'ASSIGN_USERS_TO_ROLE',
	ASSIGN_ROLE_TO_EMPLOYEES: 'ASSIGN_ROLE_TO_EMPLOYEES',
	VIEW_ALL_ROLES: 'VIEW_ALL_ROLES',
	DELETE_ROLE_CONFIRMATION: 'DELETE_ROLE_CONFIRMATION',
	VIEW_EDIT_EMPLOYEE_ROLE: 'VIEW_EDIT_EMPLOYEE_ROLE',
	REMOVE_ROLE_CONFIRMATION: 'REMOVE_ROLE_CONFIRMATION',
	VIEW_ASSIGNED_USERS: 'VIEW_ASSIGNED_USERS',
	ONBOARDING_MODAL: 'ONBOARDING_MODAL'
};

export const ROLE_ACCESS_TOUR = {
	UI_STORAGE_KEY: 'role_access_ui',
	TOTAL_FEATURES: 2,
	TOP_FEATURE: 1,
	SEARCH_FEATURE: 2
} as const;

export const HELP_TEXT = {
	why: 'Why should I use Role & Access section?',
	how: 'How to use Role & Access section?'
};

export const coachmarkTextConf = {
	top: {
		heading: 'Create and View Roles',
		subHeading: ['Create new roles and provide module view/edit access as per your requirement.', 'View all roles, assigned users and modules associated with the roles.']
	},
	search: {
		heading: 'Search and Edit Roles',
		subHeading: ['Search and view specific existing roles.', 'Edit permissions and add new users to existing roles.', 'Assign users to different roles (when a user is assigned to a new role previous roles will overridden).']
	}
};

export const onboardingModalConfig = {
	heading: 'Create a Role Now!',
	desc: 'Set up roles to control what each team member can view or manage across modules.',
	cta: 'LET\'S GET STARTED',
	img: roleAccessOnboardImage,
	imgAlt: 'Role & Access onboarding',
	customClass: 'roleAccessOnboardingModal',
	features: [
		{
			title: 'Create New Roles',
			desc: 'Define roles with access to specific modules — e.g. a Finance Manager can be limited to Reports and Invoices only.',
			Icon: React.createElement(EmployeeIcons, { icon: 'addCircleIcon' })
		},
		{
			title: 'Assign Flexible Module Permissions',
			desc: 'Grant View-only or Edit access across Wallet, Reports, Invoices, Policy and more.',
			Icon: React.createElement(EmployeeIcons, { icon: 'starCircleIcon' })
		},
		{
			title: 'Control Access Securely',
			desc: 'Keep sensitive data protected by ensuring every user sees only what their role allows.',
			Icon: React.createElement(EmployeeIcons, { icon: 'shieldCircleIcon' })
		}
	]
};

export const VIEW_ALL_ROLES_CONSTANTS = {
	MODAL_TITLE_PREFIX: 'All Active Roles',
	ROLE: 'Role',
	SEARCH_PLACEHOLDER: 'Search Roles',
	BTN_CREATE_NEW_ROLE: 'CREATE A NEW ROLE',
	BTN_OKAY: 'OKAY, GOT IT',
	PERMISSIONS_LABEL: 'Permissions',
	USER: 'user',
	NO_USER: 'No',
	USERS_ASSIGNED_SUFFIX: 'assigned',
	NO_ROLES_FOUND: 'No roles found matching your search',
	NO_ACTIVE_ROLES: 'No active roles available',
	ERROR_HEADING: 'Failed to Load Roles',
	ERROR_TEXT: 'Unable to fetch roles at the moment.',
	ERROR_CTA: 'try again'
};

export const viewAllRolesModalData = {
	title: '',
	customClass: 'viewAllRolesModal',
	closeBtnClass: 'close-ico'
};

export const ROLE_TYPES = {
	SYSTEM: 'SYSTEM',
	CUSTOM: 'CUSTOM'
} as const;

export const ASSIGN_ROLE_TO_EMPLOYEES_CONFIG = {
	MODAL_TITLE: 'Assign Role for Selected Employees',
	MODAL_SUBTITLE: 'You can assign an existing role for the selected employees or choose to create a new role for them.',
	BTN_CREATE_NEW_ROLE: 'CREATE NEW ROLE',
	BTN_CONFIRM: 'CONFIRM ASSIGNMENT',
	MORE_SUFFIX: 'More',
	PERMISSIONS_LABEL: 'Permissions',
	MAX_VISIBLE_PERMISSIONS: 4
};

export const assignRoleToEmployeesModalData = {
	title: '',
	customClass: 'assignRoleToEmployeesModal',
	closeBtnClass: 'close-ico'
};

export const VIEW_ROLE_FOR_SELECTED_EMPLOYEES_CONFIG = {
	MODAL_TITLE: 'View Role for Selected Employees',
	MODAL_SUBTITLE: 'You can assign an existing role for the selected employees or choose to create a new role for them.',
	CURRENT_ROLES_LABEL: 'Current Roles Assigned',
	NO_ROLES_TEXT: 'No roles assigned',
	BTN_ASSIGN_ROLE: 'ASSIGN A ROLE',
	BTN_OKAY: 'OKAY, GOT IT',
	ERROR_HEADING: 'Failed to Load Employee Roles',
	ERROR_TEXT: 'Unable to fetch the assigned roles at the moment.',
	ERROR_CTA: 'try again'
};

export const viewRoleForSelectedEmployeesModalData = {
	title: '',
	customClass: 'viewRoleForSelectedEmployeesModal',
	closeBtnClass: 'close-ico'
};

export const REMOVE_ROLE_CONFIRMATION_CONFIG = {
	TITLE_PREFIX: 'Remove ',
	TITLE_SUFFIX: ' Role?',
	SUBTITLE_PREFIX: 'Are you sure you want to remove the ',
	SUBTITLE_SUFFIX: ' role of following employee?',
	EMPLOYEE_NAME_LABEL: 'EMPLOYEE NAME',
	EMPLOYEE_EMAIL_LABEL: 'EMAIL ID',
	BTN_REMOVE: 'YES, REMOVE',
	ADMIN_REVOKE_WARNING: 'The admin rights from this employee will be revoked once confirmed.'
};

export const removeRoleConfirmationModalData = {
	title: '',
	customClass: 'removeRoleConfirmationModal',
	closeBtnClass: 'close-ico'
};

export const VIEW_ASSIGNED_USERS_PAGE_LIMIT = 50;
export const VIEW_ASSIGNED_USERS_INITIAL_PAGE = 0;

export const VIEW_ASSIGNED_USERS_CONFIG = {
	MODAL_TITLE_PREFIX: 'Assigned Users as',
	ERROR_HEADING: 'Failed to Load Assigned Users',
	ERROR_TEXT: 'Unable to fetch assigned users at the moment.',
	ERROR_CTA: 'try again',
	NO_EMPLOYEES_TEXT: 'No employees assigned to this role',
	TABLE_COLUMNS: {
		NAME: 'Name',
		EMAIL: 'Email'
	}
};

export const viewAssignedUsersModalData = {
	title: '',
	customClass: 'viewAssignedUsersModal',
	closeBtnClass: 'close-ico'
};

export const ROLE_ACCESS_PAGE_CONFIG = {
	HEADING: 'Role & Access',
	ACTIVE_ROLES_HEADING: 'Active Roles',
	BTN_CREATE_NEW_ROLE: '+ CREATE NEW ROLE',
	EMPTY_STATE_TEXT: 'You have not created any roles yet for the employees of your organisation.',
	STATS: [
		{ key: 'rolesCount', label: 'Total Roles' },
		{ key: 'assignedUsers', label: 'Assigned Users' },
		{ key: 'activePermissions', label: 'Active Permissions' }
	],
	VIEW_USERS: 'View Users',
	ASSIGN_USERS: 'Assign Users'
} as const;